const img = '';


export { img }
